import React from "react"
import { useIntl } from "react-intl"
import { PageLayout } from "#/features/global-ui/page-layout"
import { PageHeader } from "#/features/global-ui/page-header"
import { LoadingInner } from "#/components/views/Loading"
import { Title } from "#/services/page-title/Title"
import { faqsLabelMessage } from "#/pages/faqs/messages"

// The consumer package is code-split and lazy-loaded (mirroring Root.tsx), so none of the
// package's FAQ code loads until a signed-in member navigates to this page. React.lazy
// infers the route's prop types from the dynamic import.
const ConsumerFaqRoute = React.lazy(() => import("@internal/consumer").then((m) => ({ default: m.ConsumerFaqRoute })))

export default function ConsumerFaqPage(): JSX.Element {
  const intl = useIntl()
  // The same "FAQs" message the enterprise help-centre nav item uses, so the two surfaces can't end
  // up with differently-translated titles — it carries the note telling translators not to render
  // F-A-Q-S literally. One value for both the browser tab and the page's own headline, the way
  // `pages/consumer/carrot-rx/page.tsx` does it.
  const pageTitle = intl.formatMessage(faqsLabelMessage)
  return (
    <PageLayout header={<PageHeader pageTitle={pageTitle} />}>
      {/* Without this the tab falls through to `titleMap`'s "Page not found" default — the map has no
          `/consumer/faq` entry. The enterprise FAQs page titles itself the same way. */}
      <Title title={pageTitle} />
      <React.Suspense fallback={<LoadingInner />}>
        {/* This host page only mounts for authenticated members (routed inside the authed
            NavLayout chrome), so `isLoggedIn` is always true here. */}
        <ConsumerFaqRoute isLoggedIn={true} />
      </React.Suspense>
    </PageLayout>
  )
}
